<template>
  <v-dialog
    v-model="showModal"
    persistent
    :max-width="getWidth"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h3 style="word-break: break-word">{{ showTitle }}</h3>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <span v-html="showText"></span>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <template >
        <el-button
          v-if="!positiveChoiceOnly"
          :title="falseText"
          :loading="loading"
          @click.native.stop="closeModal()"
          color="secondary"
        />
        <el-button
          :title="trueText"
          :loading="loading"
          @click.native="confirmData()"
          color="primary"
        />
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalCustom',
  props: {
    value: Boolean,
    title: String,
    text: String,
    mid: Boolean,
    positiveChoiceOnly: Boolean,
    trueText: { type: String, default: 'Taip' },
    falseText: { type: String, default: 'Ne' },
    loading: { type: Boolean, default: false },
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
    }
  },
  computed: {
    getWidth(){
      return this.mid ?  '600px' : '300px'
    },
    showTitle() {
      return this.$t(this.title)
    },
    showText() {
      return this.text
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    this.modalloading = false
  },
  methods: {
    closeModal() {
      this.showModal = false
      this.$emit('closeModal')
    },
    cancel() {
      this.closeModal()
    },
    confirmData() {
      this.$emit('confirmData')
    },
  },
}
</script>
<style lang="scss" scoped></style>
